import React, { useState } from "react";

// Define the available roles
const roles = [
  { id: "user", name: "User", icon: "👤" },
  { id: "advertiser", name: "Advertiser", icon: "🏪" },
];

function SelectRole() {
  // State to track the currently selected role
  const [selectedRole, setSelectedRole] = useState("user"); // Default to 'User'

  // Handler for when a role card is clicked
  const handleRoleSelect = (roleId) => {
    setSelectedRole(roleId);
  };

  // Handler for the Next button
  const handleNext = () => {
    console.log(`Navigating as: ${selectedRole}`);
    // TODO: Add navigation logic based on selectedRole
  };

  return (
    <>
      <section className="py-12 lg:py-24">
        <div className="container">
          <div className="flex flex-col items-center justify-center bg-white">
            <h1 className="headings-h1 text-zinc-950 mb-10">Select the Role</h1>

            <div className="bg-white border-1 border-zinc-100 p-[15px] md:p-[30px] lg:p-[50px] shadow-[0px_2px_24px_0px_rgba(0,0,0,0.05)] rounded-[10px]">
              {/* Role Selection Grid */}
              <div className="flex flex-wrap justify-center gap-6 mb-10 max-w-lg w-full">
                {roles.map((role) => (
                  <div
                    key={role.id}
                    className={`flex flex-col items-center justify-center p-4 min-w-[195px] w-full sm:w-48 h-48 rounded-[16px]
              cursor-pointer transition-all duration-300 ease-in-out
              ${
                selectedRole === role.id
                  ? "border-2 border-red-400 bg-white"
                  : "border border-zinc-200 bg-white hover:border-red-200"
              }`}
                    onClick={() => handleRoleSelect(role.id)}
                  >
                    <img
                      src={`/images/${role.id}.svg`}
                      alt={`${role.name} Icon`}
                      className="w-16 h-16"
                    />
                    <span className="headings-h3 mt-4">{role.name}</span>
                  </div>
                ))}
              </div>

              {/* Next Button */}
              <button onClick={handleNext} className="btn btn-pri w-full">
                Next
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SelectRole;
